import { render, staticRenderFns } from "./Create.vue?vue&type=template&id=4b04327d&scoped=true"
import script from "./Create.vue?vue&type=script&lang=js"
export * from "./Create.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b04327d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/crm1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b04327d')) {
      api.createRecord('4b04327d', component.options)
    } else {
      api.reload('4b04327d', component.options)
    }
    module.hot.accept("./Create.vue?vue&type=template&id=4b04327d&scoped=true", function () {
      api.rerender('4b04327d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/crm/contacts/Create.vue"
export default component.exports